import { render, staticRenderFns } from "./AddEditGallery.vue?vue&type=template&id=3711d09e&"
import script from "./AddEditGallery.vue?vue&type=script&lang=js&"
export * from "./AddEditGallery.vue?vue&type=script&lang=js&"
import style0 from "./AddEditGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports